(function($) {

	//
	$(document).ready(function() {

		//
		var $body = $('body');

		var openDialog = function(dialog) {
			if(!dialog.parents("main").length) {
				$('main').append(dialog);
			}
			dialog.attr('open', !dialog.attr('open'));
			$body.css('top', -($(window).scrollTop()) + 'px').addClass('dialog-open');
		}

		var closeDialog = function(dialog) {
			dialog.attr('open', !dialog.attr('open'));

			// Get body's top css attrubute.
			var top = Math.abs(parseInt($('body').css('top')));

			// Set body's top css attribute to current scroll top position, and open navigation.
			$body.css('top', 0).removeClass('dialog-open');

			// Set scroll position to bod's old top value.
			$(window).scrollTop(top);
		}

		$body.on('click', '[data-toggle-dialog]', function(event) {
			//
			event.preventDefault();

			//
			var $toggler = $(this);
			var $targetId = $toggler.attr('data-toggle-dialog');
			var $targetElement = $('#' + $targetId);

			if($targetElement.attr('open')) {
				closeDialog($targetElement);
			} else {
				openDialog($targetElement);
			}
		});

		$body.on('click', 'dialog', function() {
			closeDialog($(this));
		});

		$body.on('click', 'dialog .dialog-content', function(event) {
			event.stopPropagation();
		});
	})
})(window.jQuery);
